import React from 'react';
import {VStack} from '@tempo/core';
import ArtistClaimDetails from './ArtistClaimDetails';
import type {ManagerClaim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import Td from '@components/Table/core/Td';
import {useTableContext} from '@components/Table';
import {ClaimTableColumn} from '@deezer/next/features/ClaimAccess/components/ClaimTable/types';

type ManagerClaimCollapsedContentProps = {
	claim: ManagerClaim;
};

const ManagerClaimCollapsedContent = ({
	claim,
}: ManagerClaimCollapsedContentProps) => {
	const {columns} = useTableContext<ClaimTableColumn>();

	return (
		<>
			{columns.map((column, index) => {
				const key = column.id + index;
				switch (column.id) {
					case ClaimTableColumn.DETAILS:
						return (
							<Td key={key}>
								<VStack spacing="spacing.s" alignItems="initial">
									{claim.artists.map(artist => (
										<ArtistClaimDetails
											key={artist.artistId}
											artist={{...artist, id: artist.artistId}}
										/>
									))}
								</VStack>
							</Td>
						);
					default:
						return <Td key={key} display={column.display} />;
				}
			})}
		</>
	);
};

export default ManagerClaimCollapsedContent;
